import React, { Component } from "react";
import Home from "./Home";
import { BrowserRouter as Router, Route } from "react-router-dom";

class App extends Component {

    render() {
        return (
            <Router>
                    <Route path="/" exact component={NoElection} />
                    <Route path="/:election_id" exact component={Home} />
            </Router>
        );
    }
}

class NoElection extends Component {
    render() {

        return (
            <div className="container">
                <h3>Bulletin</h3>
                <p>
                    Sistema de consulta de datos electorales
                </p>
            </div>
        );

    }
}

export default App;